import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { from } from 'rxjs';

export interface IFormGroupConverter<REC> {
  convertTo(r: REC): FormGroup;
}

export class FormArrayDataSource<REC> extends MatTableDataSource<AbstractControl> {
  constructor(
    private formArray: FormArray,
    private converter: IFormGroupConverter<REC>
  ) {
    super();
    this.data = this.formArray.controls;
  }

  /**
   * Adds multiple records to the form array.
   * @param records The records to add.
   * @returns An observable that emits when the records have been added.
   */
  addRecords(records: REC[]) {
    const formGroups = records.map((r) => {
      const fg = this.converter.convertTo(r);
      fg.markAllAsTouched();
      return fg;
    });
    return from(
      Promise.resolve().then(() => {
        formGroups.forEach((fg) => this.formArray.push(fg));
      })
    );
  }

  /**
   * Removes a record from the form array.
   * @param index The index of the record to remove.
   */
  remove(index: number) {
    this.formArray.removeAt(index);
  }

  /**
   * Removes a record from the form array by field value.
   * @param field The field to match.
   * @param value The value to match.
   */
  removeByValue(field: string, value: unknown) {
    this.formArray.removeAt(this.formArray.value.findIndex((object: { [key: string]: unknown }) => object[field] === value));
  }
}
